import React, { useCallback, useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRequests } from "../../../../redux/actions/autoLombardActions";
import { RequestActions, RequestListTable } from "..";
import { pageOptions, wordForms } from "../../../../helpers/data-constants";
import { returnEndStr } from "../../../../helpers/common";
import { Pagination } from "../../../utilites";
import Loader from "../../Loader";

import "../../styles/autoLombardLayout.scss";

const RequestListComponent = ({ setTitlePage }) => {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const [state, setState] = useState({
    currentPage: 1,
    pageRange: pageOptions[0].value,
  });
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    filters: {},
    sortBy: "status",
    descending: false,
  });

  const { accessFeatures, isLoadingConfiguration } = useSelector(
    ({ user }) => user
  );
  const { totalPages, currentPage, totalElements, requests, loading } =
    useSelector(({ autolombard }) => autolombard.requests);

  useEffect(() => {
    dispatch(fetchRequests(queryParams));
  }, [queryParams, dispatch]);

  const handleFilterChange = useCallback(
    (filterKey) => (value) => {
      setQueryParams((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          [filterKey]: value,
        },
        page: 1,
      }));
    },
    []
  );

  const handlePageChange = (page) => {
    setState((prev) => ({ ...prev, currentPage: page }));
    refreshData(page);
  };

  const refreshData = useCallback((page) => {
    const data = {
      ...queryParams,
      size: state.pageRange,
      page: page,
    };
    dispatch(fetchRequests(data));
  }, [queryParams, dispatch]);

  useEffect(() => {
    accessFeatures["title.header_section"] && setTitlePage("Заявки");
  }, [isLoadingConfiguration]);

  return (
    <>
      <div className="content-datatable-content">
        <>
          <RequestActions onFilterChange={handleFilterChange} />
          <div className="text-muted">
            <p>Найдено {returnEndStr(totalElements, wordForms.resultForms)}</p>
          </div>

          {loading ? (
            <Loader pageRange={state.pageRange} />
          ) : (
            <RequestListTable data={requests} match={match} />
          )}
        </>
      </div>
      <Pagination
        total={totalPages}
        current={currentPage}
        handlePageChange={handlePageChange}
      />
    </>
  );
};

export default RequestListComponent;
